import { useRef as r, useMemo as e } from "react";
import { createProxy as t } from "@react-input/core";
import a from "./Mask.js";
function n() {
  var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
    c = n.mask,
    o = n.replacement,
    m = n.showMask,
    s = n.separate,
    u = n.track,
    p = n.modify,
    i = r(null),
    k = r({
      mask: c,
      replacement: o,
      showMask: m,
      separate: s,
      track: u,
      modify: p
    });
  return k.current.mask = c, k.current.replacement = o, k.current.showMask = m, k.current.separate = s, k.current.track = u, k.current.modify = p, e(function () {
    return t(i, new a(k.current));
  }, []);
}
export { n as default };